export const ProductRedirectionEvents = {
  request: 'productRedirection/FETCH_PRODUCT_REDIRECTION/request',
  loading: 'productRedirection/FETCH_PRODUCT_REDIRECTION/loading',
  refresh: 'productRedirection/FETCH_PRODUCT_REDIRECTION/refresh',
  success: 'productRedirection/FETCH_PRODUCT_REDIRECTION/success',
  failure: 'productRedirection/FETCH_PRODUCT_REDIRECTION/failure',
} as const;
